import http from '../http-common';

const GetAllSpeakers = async ({ officeId, page = 1, limit = 50, search = "" }) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (limit) params.append("limit", limit);
  if (search) params.append("search", search);

  const speakers = await http
    .get(`/speakers/${officeId}?${params.toString()}`)
    .then((response) => response.data);

  return speakers;
};

const GetAllSpeakersOfVisit = async (id) => {
  const speakers = await http.get(`/visitSpeakers/${id}`).then((response) => {
    return response.data;
  });
  return speakers;
};

const GetAllAttendeesOfVisit = async (id) => {
  const attendees = await http.get(`/visitAttendees/${id}`).then((response) => {
    return response.data;
  });
  return attendees;
};

const CreateNewSpeaker = async (newData, id) => {
  const auth = await http
    .post(`/createSpeaker/${id}`, {
      name: newData.name,
      designation: newData.designation,
      designationOther: newData.designationOther,
      practice: newData.practice,
      about: newData.about,
      audioId: newData.audioId === '' ? null : newData.audioId,
      videoId: newData.videoId === '' ? null : newData.videoId,
      photoId: newData.photoId,
      email: newData.email,
    })
    .then((response) => {
      return response.data;
    });

  return auth;
};


const GetAllAttendes = async ({ officeId, page = 1, limit = 50, search = "" }) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (limit) params.append("limit", limit);
  if (search) params.append("search", search);

  const speakers = await http
    .get(`/attendees/${officeId}?${params.toString()}`)
    .then((response) => response.data);

  return speakers;
};

const CreateNewAttendee = async (newData, id) => {
  const auth = await http
    .post(`/createAttendee/${id}`, {
      name: newData.name,
      designation: newData.designation,
      photoId: newData.photoId,
      role :newData.role
    })
    .then((response) => {
      return response.data;
    });

  return auth;
};

const UpdateAttendee = async (newData, id) => {
  const auth = await http
    .put(`/updateAttendee/${id}`, {
      name: newData.name,
      designation: newData.designation,
      photoId: newData.photoId,
      role: newData.role
    })
    .then((response) => {
      return response.data;
    });

  return auth;
};

const DeleteAttendee = async (id) => {
  const deletedData = await http
    .delete(`/deleteAttendee/${id}`)
    .then((response) => {
      return response.data;
    });
  return deletedData;
};

const UpdateSpeaker = async (updateData, id) => {
  const updatedData = await http
    .put(`/updateSpeaker/${id}`, {
      name: updateData.name,
      designation: updateData.designation,
      designationOther: updateData.designationOther,
      practice: updateData.practice,
      about: updateData.about,
      audioId: updateData.audioId === '' ? null : updateData.audioId,
      videoId: updateData.videoId === '' ? null : updateData.videoId,
      photoId: updateData.photoId,
      email: updateData.email,
    })
    .then((response) => {
      return response.data;
    });
  return updatedData;
};

const DeleteSpeaker = async (id) => {
  const deletedData = await http
    .delete(`/deleteSpeaker/${id}`)
    .then((response) => {
      return response.data;
    });
  return deletedData;
};

const CheckUserAvailability = async (email) => {
  try {
    const response = await http.get(`/user/checkAvailability/${email}`);
    return response.data;
  } catch (error) {
    throw error; 
  }
};
const SpeakerListAPI = {
  GetAllSpeakers,
  CreateNewSpeaker,
  UpdateSpeaker,
  DeleteSpeaker,
  GetAllSpeakersOfVisit,
  GetAllAttendeesOfVisit,
  CreateNewAttendee,
  UpdateAttendee,
  DeleteAttendee,
  GetAllAttendes,
  CheckUserAvailability
};

export default SpeakerListAPI;